/** True when a native bottom sheet is open — child dialogs should stack as nested. */
export function isNativeParentSheetOpen(): boolean {
  if (typeof document === "undefined") return false;
  return Boolean(
    document.body.querySelector(
      [
        '[data-state="open"][role="dialog"].native-bottom-sheet:not(.native-nested-sheet)',
        '[data-state="open"][role="dialog"].native-test-sheet',
        '[data-state="open"][role="dialog"].native-full-sheet:not(.native-nested-sheet)',
        '[data-state="open"][role="dialog"].native-leadbox-sheet:not(.native-nested-sheet)',
        '[data-state="open"][role="dialog"].native-option-sheet:not(.native-nested-sheet)',
        '[data-state="open"][role="dialog"].rounded-t-2xl:not(.native-nested-sheet)',
      ].join(", "),
    ),
  );
}
